module.exports = __webpack_public_path__ + "static/media/newYear.594d05ce.mp3";